<template>
  <div class="space">
    <div class="base-search">
      <el-input
        placeholder="请输入企业名称"
        v-model="searchValue"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
        style="width: 300px;"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
    </div>
    <div class="base-table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
        class="table"
      >
        <el-table-column type="index" width="150" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="企业名称" align="center" prop="enterpriseName"></el-table-column>
        <el-table-column label="信息来源" align="center" prop="informationSrc"></el-table-column>
        <el-table-column label="审核人" align="center" prop="reviewer"></el-table-column>
        <el-table-column label="审核状态" align="center">
          <template slot-scope="scope">
            <span>{{ getApprovalStatus(scope.row.approvalStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核意见" align="center" prop="auditOpinion"></el-table-column>
        <el-table-column label="审核时间" align="center" prop="reviewTime"></el-table-column>
        <!--<el-table-column label="是否重点推荐" align="center" prop="recommendStatus">
          <template slot-scope="scope">
            <span>{{ scope.row.recommendStatus ? '是' : '否' }}</span>
          </template>
        </el-table-column>-->
        <el-table-column width="200px" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              class="mini_btn"
              type="text"
              v-if="scope.row.type === 3 || scope.row.type === 4 || scope.row.type === 5"
              @click="handleEdit(scope.row, scope.row.type)"
            >
              编辑
            </el-button>
            <el-button
              class="mini_btn"
              v-if="scope.row.type === 1 || scope.row.type === 2"
              type="text"
              @click="handleDetail(scope.row)"
            >
              详情
            </el-button>
            <el-button
              class="mini_btn"
              v-if="
                (scope.row.type === 1 && scope.row.approvalStatus !== 4) ||
                  (scope.row.type === 2 && scope.row.approvalStatus !== 4)
              "
              type="text"
              @click="handleCheck(scope.row, 4)"
            >
              通过
            </el-button>
            <el-button
              class="mini_btn"
              v-if="
                (scope.row.type === 1 && scope.row.approvalStatus !== 4) ||
                  (scope.row.type === 2 && scope.row.approvalStatus !== 4)
              "
              type="text"
              @click="handleCheck(scope.row, 2)"
            >
              不通过
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="current_page"
      :page-size="per_page"
      layout="total,prev, pager, next"
      :total="total"
      style="text-align:left;margin:20px 0"
    ></el-pagination>
    <el-dialog
      @closed="is_submit = true"
      :title="Title"
      center
      :visible.sync="dialogForm"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <company-detail
        :data-list="ruleForm"
        :key="ruleForm ? ruleForm.id : ''"
        ref="companyDetail"
        :disabled="true"
      ></company-detail>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('dialogForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div> -->
    </el-dialog>

    <el-dialog
      @closed="is_submit = true"
      title="经营信息详情"
      center
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div class="status" :class="'status-' + (manageData ? manageData.approvalStatus : '')">
        {{ getApprovalStatus(manageData ? manageData.approvalStatus : '') }}
      </div>
      <manage-detail
        :key="manageData ? manageData.id : ''"
        :disabled="true"
        :dataList="manageData"
      ></manage-detail>
    </el-dialog>
    <!-- <el-dialog
      title="审批内容"
      center
      :visible.sync="dialogCheckVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        label-position="right"
        ref="form"
        size="small"
        :model="ruleForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="审核意见" prop="introduction">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入审核意见"
            v-model="ruleForm.introduction"
          ></el-input>
        </el-form-item>
        <el-form-item label="附件">
          <el-upload
            class="upload-demo"
            :action="this.uploadURL"
            name="file"
            :file-list="fileList"
            :show-file-list="true"
            :on-remove="onRemove"
            :on-success="handlePictureCardPreview"
            accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
            multiple
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm('dialogCheckVisible')">取 消</el-button>
        <el-button type="primary" @click="submitForm(2)">确 定</el-button>
      </div>
    </el-dialog> -->
    <!-- 担保需求弹框 -->
    <WarrantDialog :dialogFormVisible="warrantVisible" :queryId="warrantId" @close="closeWarrant" />
    <GuaranteeDialog
      :dialogFormVisible="guaranteeVisible"
      :queryId="guaranteeId"
      @close="guaranteeClose"
    />
    <InvestMechanDialog
      :dialogFormVisible="investMechanVisible"
      :queryId="investMechanId"
      @close="investMechanClose"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import CompanyDetail from './companyDetail.vue';
import manageDetail from './manageDetail.vue';
import WarrantDialog from './warrantDialog.vue';
import GuaranteeDialog from './guaranteeDialog.vue';
import InvestMechanDialog from './investMechanDialog.vue';

export default {
	components: {
    CompanyDetail,
    manageDetail,
    WarrantDialog,
    GuaranteeDialog,
    InvestMechanDialog
	},
	data() {
		return {
      investMechanVisible: false,
      investMechanId: '',
      guaranteeVisible: false,
      guaranteeId: '',
      warrantId: '',
      warrantVisible: false,
			is_submit: true,
			total: 10,
			per_page: 10,
			current_page: 1,
			Title: "",
			searchValue: "",
			dialogForm: false,
      dialogFormVisible1: false,
			fileList: [],
			tableData: [],
			ruleForm: {
				messageType: '001',
			},
      rules: {
        image: [{ required: true, trigger: 'blur', message: '请上传头像' }]
      },
      manageData: null
      // dialogCheckVisible: false
		};
	},
	created() {
		this.search();
	},
	methods: {
    closeWarrant(flag) {
      if (flag) {
        this.getData();
        this.warrantVisible = false;
      }

      this.warrantVisible = false;
    },

    guaranteeClose(flag) {
      if (flag) {
        this.getData();
        this.guaranteeVisible = false;
      }

      this.guaranteeVisible = false;
    },

    investMechanClose(flag) {
      if (flag) {
        this.getData();
        this.investMechanVisible = false;
      }

      this.investMechanVisible = false;
    },
		getApprovalStatus(status) {
			switch(status) {
				case 1:
					return '待审核';
				case 2:
					return '不通过';
				case 3:
					return '退回';
				case 4:
					return '通过';
			}
		},
		getData(item) {
			const params = {
				page: this.current_page,
				pageSize: this.per_page,
				...item,
			}
			this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/enterprises-history/page`, params).then((res) => {
				if (res.code == 0) {
					this.tableData = res.data.data;
					this.total = res.data.total;
					this.per_page = res.data.per_page;
					this.current_page = res.data.current_page * 1;
				}
			});
		},
		//搜索
		search() {
			this.getData({page: 1, keyword: this.searchValue});
		},
		//编辑
		handleDetail(row) {
      if(row.type === 1) {
        this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/enterprises-history/get?id=${row.id}`)
        .then((res) => {
          if (res.code == 0) {
            const data = res.data;
            if(data) {
              this.ruleForm = {
                ...data
              };
              this.ruleForm = data;
              this.ruleForm.area = data.area ? JSON.parse(data.area) : null
              this.ruleForm.industry = data.industry ? JSON.parse(data.industry) : null
              this.ruleForm.registeredAddress = data.registeredAddress? JSON.parse(data.registeredAddress) : null
              this.ruleForm.physicalAddress = data.physicalAddress? JSON.parse(data.physicalAddress) : null
              this.ruleForm.markGuaranteeTypeId = data.markGuaranteeTypeId
              this.ruleForm.approvalStatus = data.servicesApprovalStatus
              this.ruleForm.investmentFirmsIds = data.investmentFirmsId ? [data.investmentFirmsId] : []
              this.fileList = data.fileList ? JSON.parse(data.fileList) : []
              this.dialogForm = true;
              this.Title = "详情";
            }
          } else {
            this.$message({
              message: "失败！",
              type: "error",
            });
          }
        });
      } else if(row.type === 2) {
        this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/needs-apply-manage/get?id=${row.id}`)
        .then((res) => {
          if (res.code == 0) {
            this.manageData = res.data;
            this.dialogFormVisible1 = true
          }
        })
      }
		},
    // 投资、金融、担保机构简介编辑操作
    handleEdit(row, type) {
      if (type === 3) {
        // 投资机构
        this.investMechanId = row.id;
        this.investMechanVisible = true;
      } else if (type === 4) {
        // 金融机构
        this.guaranteeId = row.id;
        this.guaranteeVisible = true;
      } else if (type === 5 ) {
        // 担保机构
        this.warrantId = row.id;
        this.warrantVisible = true;
      }
    },
    // 审核
    handleCheck(item, type) {
     let url = '';
     if(item.type === 1) {
      url = `${this.urlConfig.devUrl}apij2/admin-api/finance/enterprises-history/updateApprovalStatus`;
     } else if (item.type === 2) {
       url = `${this.urlConfig.devUrl}apij2/admin-api/finance/needs-apply-manage/updateApprovalStatus`;
     } else {
       url = `${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/updateApprovalStatus`;
     }
      this.http.post(url, {id: item.id, approvalStatus: type, type: this.ruleForm.type}).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "状态修改成功",
          });
          this.search();
        }
      });
    },

		//翻页
		handleCurrentChange(e) {
			this.getData({page: e, keyword: this.searchValue});
		},
		//取消
		closeForm(name) {
			this[name] = false
		},
		//提交
		submitForm() {
			this.$refs.companyDetail.parentHandleclick((params) => {
        this.http.post(`${this.urlConfig.devUrl}apij2/admin-api/finance/enterprises-history/update`, params).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "编辑成功",
            });
            this.dialogForm = false;
            this.search();
          }
        });
      })
		},
		// onRemove(file, fileList) {
    //   this.fileList = this.getList(fileList);
    // },
    // handlePictureCardPreview(response, file, fileList) {
    //   this.fileList = this.getList(fileList);
    // },
    // getList(fileList) {
    //   return fileList.map((el) => {
    //     return {
    //       name: el.name,
    //       url: el?.url || el?.response?.data.store_result,
    //       uid: el.uid,
    //     };
    //   });
    // },
	},
};
</script>

<style scoped lang="scss">
.space {
  height: 100%;
  width: 100%;

  .base-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .base-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  /deep/ .el-upload {
    border: 1px solid #ffffff !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
/deep/ .upload-demo {
  border: none !important;
}

.status {
  padding-bottom: 20px;
  text-align: center;
  font-size: 16px;
}
.status-1 {
  color: #909399;
}
.status-2,
.status-3 {
  color: #f56c6c;
}
.status-4 {
  color: #67c23a;
}
</style>
